export const buildTimeInputValueOnMinuteChange = (currentValue: string, minutes: string): string => {
  const hours24 = currentValue.split(':')[0] ?? '00';
  return `${hours24}:${minutes}`;
};
